import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import logoWhite from '../assets/logo_white_transparent.png';

const FooterEl = styled.footer`
  background:#000008;border-top:1px solid rgba(255,255,255,0.05);padding:64px 80px 0;
  @media(max-width:900px){padding:50px 24px 0}
`;
const Grid = styled.div`
  max-width:1360px;margin:0 auto;
  display:grid;grid-template-columns:1.5fr 1fr 1fr 1fr 1fr;gap:44px;padding-bottom:56px;
  @media(max-width:1100px){grid-template-columns:1fr 1fr 1fr;gap:36px}
  @media(max-width:700px){grid-template-columns:1fr 1fr;gap:32px}
  @media(max-width:480px){grid-template-columns:1fr;gap:28px}
`;
const Brand = styled.div`
  @media(max-width:1100px){grid-column:1/-1}
`;
const LogoWrap = styled.div`margin-bottom:18px;img{height:42px;object-fit:contain}`;
const Tagline = styled.p`
  font-size:13px;color:rgba(255,255,255,.72);line-height:1.72;
  margin-bottom:26px;max-width:260px;font-family:'Rajdhani',sans-serif;
`;
const Socials = styled.div`display:flex;gap:8px`;
const SocialBtn = styled.a`
  width:36px;height:36px;border:1px solid rgba(255,255,255,.25);
  display:flex;align-items:center;justify-content:center;
  font-size:12px;font-weight:700;text-decoration:none;color:rgba(255,255,255,.75);
  transition:all .3s;font-family:'Rajdhani',sans-serif;
  &:hover{border-color:#00A3FF;color:#00A3FF;box-shadow:0 0 12px rgba(0,163,255,.2)}
`;

const Col = styled.div``;
const ColTitle = styled.h4`
  font-family:'Space Mono',monospace;font-size:9px;letter-spacing:.32em;
  color:rgba(255,255,255,.55);margin-bottom:20px;text-transform:uppercase;
`;
const ColList = styled.ul`list-style:none;display:flex;flex-direction:column;gap:11px`;
const ColA = styled.a`
  font-size:14px;color:rgba(255,255,255,.82);text-decoration:none;
  transition:color .3s;font-family:'Rajdhani',sans-serif;
  &:hover{color:#00A3FF}
`;
const ColL = styled(Link)`
  font-size:14px;color:rgba(255,255,255,.82);text-decoration:none;
  transition:color .3s;font-family:'Rajdhani',sans-serif;
  &:hover{color:#00A3FF}
`;

const Bottom = styled.div`
  max-width:1360px;margin:0 auto;padding:24px 0;
  border-top:1px solid rgba(255,255,255,.05);
  display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:12px;
  @media(max-width:600px){flex-direction:column;align-items:flex-start;gap:14px}
`;
const Copy = styled.span`
  font-family:'Space Mono',monospace;font-size:9px;
  color:rgba(255,255,255,.5);letter-spacing:.06em;
`;
const StudioCredit = styled.a`
  display:flex;align-items:center;gap:10px;text-decoration:none;
  font-family:'Space Mono',monospace;font-size:9px;letter-spacing:.12em;
  color:rgba(255,255,255,.45);text-transform:uppercase;transition:color .3s;
  &:hover{color:rgba(255,255,255,.75)}
  &:hover img{filter:drop-shadow(0 0 8px rgba(0,163,255,.9))}
`;
const StudioLogo = styled.img`
  height:22px;width:auto;object-fit:contain;
  filter:drop-shadow(0 0 4px rgba(0,163,255,.5));
  transition:filter .3s;
`;
const GueblyTag = styled.a`
  font-family:'Space Mono',monospace;font-size:9px;color:rgba(0,163,255,.7);
  letter-spacing:.15em;text-decoration:none;text-transform:uppercase;transition:color .3s;
  &:hover{color:#00A3FF}
`;

export default function Footer() {
  const { t } = useTranslation();

  return (
    <FooterEl>
      <Grid>
        <Brand>
          <LogoWrap><img src={logoWhite} alt="Guebly Games"/></LogoWrap>
          <Tagline>{t('footer.tagline')}</Tagline>
          <Socials>
            <SocialBtn
              href="https://www.instagram.com/gueblygames"
              target="_blank" rel="noopener noreferrer"
              title="Instagram"
            >
              IG
            </SocialBtn>
            <SocialBtn
              href="https://discord.gg/gueblygames"
              target="_blank" rel="noopener noreferrer"
              title="Discord"
            >
              DC
            </SocialBtn>
            <SocialBtn
              href="https://twitter.com/gueblygames"
              target="_blank" rel="noopener noreferrer"
              title="Twitter / X"
            >
              𝕏
            </SocialBtn>
            <SocialBtn href="mailto:contato@guebly.com.br" title="E-mail">
              @
            </SocialBtn>
          </Socials>
        </Brand>

        <Col>
          <ColTitle>{t('footer.productsCol')}</ColTitle>
          <ColList>
            <li><ColL to="/engine">{t('footer.engine')}</ColL></li>
            <li><ColA href="https://store.games.guebly.com.br" target="_blank" rel="noopener noreferrer">{t('footer.store')}</ColA></li>
            <li><ColA href="https://launcher.games.guebly.com.br" target="_blank" rel="noopener noreferrer">{t('footer.launcher')}</ColA></li>
            <li><ColA href="https://docs.games.guebly.com.br" target="_blank" rel="noopener noreferrer">{t('footer.docs')}</ColA></li>
          </ColList>
        </Col>

        <Col>
          <ColTitle>{t('footer.devsCol')}</ColTitle>
          <ColList>
            <li><ColA href="https://dev.games.guebly.com.br" target="_blank" rel="noopener noreferrer">{t('footer.devPortal')}</ColA></li>
            <li><ColA href="https://docs.games.guebly.com.br/api" target="_blank" rel="noopener noreferrer">{t('footer.apiDocs')}</ColA></li>
            <li><ColA href="https://dev.games.guebly.com.br" target="_blank" rel="noopener noreferrer">{t('footer.publishGame')}</ColA></li>
            <li><ColL to="/games">{t('footer.allGames')}</ColL></li>
          </ColList>
        </Col>

        <Col>
          <ColTitle>{t('footer.communityCol')}</ColTitle>
          <ColList>
            <li><ColA href="https://discord.gg/gueblygames" target="_blank" rel="noopener noreferrer">{t('footer.discord')}</ColA></li>
            <li><ColA href="https://twitter.com/gueblygames" target="_blank" rel="noopener noreferrer">{t('footer.twitter')}</ColA></li>
            <li><ColA href="https://www.youtube.com/@gueblygames" target="_blank" rel="noopener noreferrer">{t('footer.youtube')}</ColA></li>
            <li><ColA href="https://www.instagram.com/gueblygames" target="_blank" rel="noopener noreferrer">Instagram</ColA></li>
          </ColList>
        </Col>

        <Col>
          <ColTitle>{t('footer.legalCol')}</ColTitle>
          <ColList>
            <li><ColA href="https://www.guebly.com.br/termos" target="_blank" rel="noopener noreferrer">{t('footer.terms')}</ColA></li>
            <li><ColA href="https://www.guebly.com.br/privacidade" target="_blank" rel="noopener noreferrer">{t('footer.privacy')}</ColA></li>
            <li><ColA href="https://www.guebly.com.br/lgpd" target="_blank" rel="noopener noreferrer">{t('footer.lgpd')}</ColA></li>
            <li><ColA href="mailto:contato@guebly.com.br">{t('footer.contact')}</ColA></li>
          </ColList>
        </Col>
      </Grid>

      <Bottom>
        <Copy>{t('footer.copyright', { year: new Date().getFullYear() })}</Copy>
        <StudioCredit href="https://studio.guebly.com.br" target="_blank" rel="noopener noreferrer">
          {t('footer.developedBy')}
          <StudioLogo src="https://studio.guebly.com.br/studio.png" alt="Guebly Studio" />
        </StudioCredit>
        <GueblyTag href="https://www.guebly.com.br" target="_blank" rel="noopener noreferrer">
          {t('footer.partOf')}
        </GueblyTag>
      </Bottom>
    </FooterEl>
  );
}
